import { Reveal } from "./Reveal";

export default function NatureBand({ content = {} }) {
  return (
    <section data-testid="nature-band" className="relative overflow-hidden bg-upland-grey">
      <div className="relative h-[60vh] md:h-[80vh] w-full">
        <img
          src="https://images.unsplash.com/photo-1780162926549-aa6102ffc2df?q=85&w=2000&auto=format&fit=crop"
          alt="Sunlight filtering through a dense, towering forest"
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* legibility + blend */}
        <div className="absolute inset-0 bg-upland-green/45" />
        <div className="absolute inset-0 bg-gradient-to-b from-upland-grey via-transparent to-upland-grey" />

        <div className="relative z-10 h-full flex items-center">
          <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-upland-creme/80 mb-5">{content.band_overline || "The Upland Standard"}</p>
              <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl text-upland-creme leading-[1.05] max-w-4xl drop-shadow-sm">
                {content.band_title || "Like the forest, enduring businesses are built on depth, patience, and quiet strength."}
              </h2>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
